<script lang="ts">
  import Logo from "../assets/logo.svg";
  import Dropdown from "./Dropdown.svelte";
  import { copy } from "../lib/stores/copy";
  import * as Language from "../lib/stores/language";
  import { getLanguageNativeName } from "../lib/helpers/language";
  import SUPPORTED_LANGUAGES from "../lib/constants/languages";
  import { storeSelector } from "../lib/helpers/countryStore";
  import { onMount, onDestroy } from "svelte";
  import { isDemo } from "../lib/stores/mode";
  import { isPrimaryCampaign } from "../lib/constants/countries";
  import { countryStore } from "../lib/stores/country";

  let isMenuOpen = false;
  let menuContainer: HTMLDivElement;

  $: languages = SUPPORTED_LANGUAGES.map(({ key, defaultValue }) => ({
    key: key,
    value: getLanguageNativeName(key)?.toUpperCase() ?? defaultValue
  }));

  const handleClickOutside = (event: MouseEvent) => {
    if (isMenuOpen && menuContainer && !menuContainer.contains(event.target as Node)) {
      isMenuOpen = false;
    }
  };

  onMount(() => {
    document.addEventListener('click', handleClickOutside);
  });

  onDestroy(() => {
    document.removeEventListener('click', handleClickOutside);
  });
</script>

<header class="bg-black">
  <div class="fixed w-full h-full bg-slate-700 opacity-60 z-[-1]"></div>
  <div class="h-[70px] max-w-[1788px] flex items-center px-4 mx-auto justify-between tablet:px-10">
    <a href="/" class="max-w-[200px] w-full flex items-center justify-between mr-[24px] min-[380px]:max-w-[230px] tablet:max-w-[290px]">
      <img src={Logo} alt={$copy.header.ariaLabels.logo}>
    </a>
    {#if isPrimaryCampaign}
      <div class="relative" role="menubar" bind:this={menuContainer}>
        <button
          class="nav-bar absolute translate-x-[-100%] tablet:translate-x-[-50%] translate-y-[-50%] z-[155] block bg-transparent overflow-hidden tabletLg:hidden"
          tabindex="0"
          aria-label={$copy.header.ariaLabels.menuButton}
          on:click={() => isMenuOpen = true}
        >
          <div class="nav-bar__hamburger cursor-pointer">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
        <div class:translate-x-full={!isMenuOpen} class="
          nav-bar__content min-w-[260px] flex items-center fixed right-0 top-0 bottom-0 h-full bg-dark z-[160] border-solid border-s border-primary transition-[transform]
          tabletLg:relative tabletLg:border-none tabletLg:translate-x-0
        ">
          <div
            class="flex w-full h-screen tabletLg:h-full tabletLg:pb-0 relative px-[24px] pt-[64px] tabletLg:px-0 tabletLg:pt-0 flex-col tabletLg:flex-row overflow-y-auto tabletLg:overflow-y-visible"
            class:pb-16={isDemo()}
            class:pb-0={!isDemo()}
          >
            <button on:click={() => isMenuOpen = false} class="tabletLg:hidden text-4xl text-primary fixed z-[200] top-[1rem] right-[1rem] leading-[30px]">&#x2715;</button>
            <button
              on:click={() => storeSelector($countryStore)}
              class="std-dropdown__button relative w-full flex text-[15px] h-[32px] px-[8px] mb-8 tabletLg:mb-0 text-white font-medium items-center justify-center font-roboto border-solid border-transparent bg-transparent z-[1] uppercase transition-[border] tabletLg:w-auto tabletLg:border-x tabletLg:border-t text-center">
              <span class="relative z-[1]">
                {@html $copy.header.menus.orderFromLittleCaesars}
              </span>
            </button>
            {#if isPrimaryCampaign}
              <Dropdown
                copy={$copy.header.menus.chooseYourLanguage}
                items={languages}
                onSelect={(item) => Language.set(item)} />
            {/if}
          </div>
        </div>  
      </div>
    {/if}
  </div>
</header>
